import React, { useContext } from 'react';
import { DataContext, RouteContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isFunction, trigger } from '@philips-internal/oswald-ui-utils';
import { InternalTab } from '../internal-tab/internal-tab.js';
import './tab-item.css';
function getCompleteRoute(routeContext, route) {
    return routeContext ? routeContext.nestedRoute(route) : route;
}
function TabItem(props) {
    const { active, index, route, onClick, onContextMenu, onDoubleClick } = props;
    const context = useContext(DataContext.Context);
    const isActive = (routeContext) => {
        const completeRoute = getCompleteRoute(routeContext, route);
        return Boolean(active || HistoryService.matchRouteWith(completeRoute));
    };
    const executeEvent = (routeContext, callback) => {
        if (route) {
            const completeRoute = getCompleteRoute(routeContext, route);
            return HistoryService.push(completeRoute, context);
        }
        if (isFunction(callback)) {
            callback(new ClickEvent({ value: index }));
        }
    };
    return (React.createElement(RouteContext.Context.Consumer, null, routeContext => (React.createElement("div", { className: "c-tab-item" },
        React.createElement(InternalTab, { ...props, isActive: isActive(routeContext), onClick: trigger(executeEvent, routeContext, onClick), onContextMenuClick: trigger(executeEvent, routeContext, onContextMenu), onDoubleClick: trigger(executeEvent, routeContext, onDoubleClick) })))));
}
export { TabItem, };
//# sourceMappingURL=tab-item.js.map